export default __webpack_public_path__ + "static/media/twinCities1.bb93fd11.webp";